import(/* webpackMode: "eager" */ "/home/aviral/Documents/Codex/2026-08-09/ho/readest/apps/readest-app/src/app/page.tsx");
